// import Vue from 'vue';
// import ajax from '@/utils/ajax';
import authajax from '@/utils/authajax';
// import string from '@/utils/string';
// import qs from 'qs';
// 5.0电商拉取订单、商品列表接口
// const QUERY_ONLINE_GOODS_ORDER_LIST_URL = '/webim/retailCommerce/questionList';
const QUERY_ONLINE_GOODS_ORDER_LIST_URL = '/v1/commerce/c/item/list';


// interface GoodsOrderListParams {
//     kfuin: string,
//     scene: number,
//     visitorId: string,
//     secretKey: string,
//     robotId: string,
//     tab: string,
//     page: number,
//     pageSize: number,
// }


// 跟机器人后台对接，后台要求sence 写死
// 商品 1 订单 2
export const EC_SENCE = {
  goods: 1,
  order: 2,
};

/**
 * 获取商品订单列表
 * @param {Object} params 参数
 * @returns {Object}
 */
export function getGoodsOrderList(params = {
  scene: 1,
  // secretKey: '', 新版本webim 是d2参数，会放到请求头里
  robotId: '',
  channelType: 4, // webim 固定为4，由于webim sdk并没有开放方法出来获取通路类型，所以这里先写死
  tab: 1,
  page: 1,
  pageSize: 10,
}) {
  const url = QUERY_ONLINE_GOODS_ORDER_LIST_URL;
  return authajax.post(url, params)
    .then((res) => {
      const rs = {
        total: 0,
        data: [],
      };
      //   if (62005 === res.data.r || 62006 === res.data.r) {
      //     throw new Error(res.data.message);
      //     return ;
      //   }
      //   if (res.data.r === 0) {
      //     rs.total = res.data.total;
      //     rs.data = res.data.data;
      //   } else {
      //     throw new Error(res.data.message);
      //   }
      if (res.data.code === 0) {
        rs.total = res.data.data.total;
        rs.data = res.data.data.data;
      } else {
        throw new Error(res.data.message);
      }
      return rs;
    })
    .catch((error) => {
      throw error;
    });
}
